import type { SVGProps } from "react";
export interface HandsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HandsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HandsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.673 1.203a7.63 7.63 0 0 1 5.858.599l3.605 1.961a.9.9 0 0 0 .42.107h1.429a1.125 1.125 0 0 1 0 2.25h-1.43a3.1 3.1 0 0 1-1.494-.38l-3.605-1.962a5.38 5.38 0 0 0-4.13-.422l-.272.09-7.517 2.728a.625.625 0 0 0-.374.802l.056.113a.626.626 0 0 0 .745.26l.002-.001 5.256-1.896.13-.047.208-.058q.316-.075.652-.076h3.85a1.125 1.125 0 0 1 0 2.25h-3.85a.5.5 0 0 0-.158.023l-.047.016a.526.526 0 0 0 .205 1.01h2.284c.48 0 .96.068 1.422.202l3.14.906c.44.127.895.192 1.353.192h3.591l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-3.591a7.1 7.1 0 0 1-1.978-.28l-3.14-.906a2.9 2.9 0 0 0-.797-.114h-2.284a2.77 2.77 0 0 1-2.74-2.346l-2.743.99h.001a2.876 2.876 0 0 1-3.566-1.448l-.115-.271a2.874 2.874 0 0 1 1.722-3.686l7.516-2.727zM5.59 11.875c.67 0 1.335.094 1.978.28l3.14.906.197.05q.297.063.602.063h2.284a2.77 2.77 0 0 1 2.737 2.345l2.742-.989.282-.086a2.877 2.877 0 0 1 3.401 1.806l.087.281a2.875 2.875 0 0 1-1.808 3.405l-7.516 2.727a7.63 7.63 0 0 1-6.245-.47l-3.605-1.961a.9.9 0 0 0-.419-.107h-1.43a1.125 1.125 0 0 1 0-2.25h1.43c.522 0 1.036.13 1.494.379l3.605 1.963.257.13a5.38 5.38 0 0 0 4.145.201l7.516-2.727a.625.625 0 0 0 .406-.679l-.03-.123a.626.626 0 0 0-.802-.373l-.001.001-5.258 1.896-.096.035-.002-.002-.032.014a2.8 2.8 0 0 1-.858.134H9.938a1.125 1.125 0 0 1 0-2.25h3.851q.086-.001.159-.025l.045-.016a.525.525 0 0 0-.204-1.009h-2.283q-.543 0-1.074-.113l-.348-.088-3.141-.907a4.9 4.9 0 0 0-1.354-.191H2a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
